import React, { useState, useEffect, useRef } from 'react';

import { Card, Button, Space, Form, Input, InputNumber, Select, message, Spin, Alert, Popconfirm, Row, Col, Divider, Radio, Modal, Tag, Typography, Collapse } from 'antd';

import { ReloadOutlined, DownloadOutlined, UploadOutlined, DeleteOutlined, TableOutlined, SaveOutlined, SwapOutlined, LayoutOutlined, AppstoreOutlined, BorderOutlined, QuestionCircleOutlined } from '@ant-design/icons';

import axios from 'axios';

import * as XLSX from 'xlsx';
import SeatTemplateImport from './SeatTemplateImport';



const { Option } = Select;

const { Text } = Typography;
const { Panel } = Collapse;

const normalizeCustomGrid = (value, rows, cols) => {
  if (!Array.isArray(value)) return null;
  const rowCount = Math.max(Number(rows) || value.length || 0, 0);
  const colCount = Math.max(Number(cols) || value[0]?.length || 0, 0);
  if (!rowCount || !colCount) return null;
  return Array.from({ length: rowCount }, (_, rowIndex) =>
    Array.from({ length: colCount }, (_, colIndex) => value[rowIndex]?.[colIndex] !== false)
  );
};

const toSeatCoordinate = (value) => {
  const coordinate = Number(value);
  return Number.isInteger(coordinate) && coordinate > 0 ? coordinate : 0;
};

const hasStudentAssignment = (seat) => [
  seat?.student_id,
  seat?.studentId,
  seat?.student_name,
  seat?.studentName,
  seat?.student_number,
  seat?.studentNumber
].some((value) => value !== null && value !== undefined && String(value).trim() !== '');

const getSeatStudentKey = (seat) => {
  const studentId = seat?.student_id ?? seat?.studentId;
  if (studentId !== null && studentId !== undefined && String(studentId).trim()) return `id:${studentId}`;
  const studentNumber = seat?.student_number ?? seat?.studentNumber;
  if (studentNumber !== null && studentNumber !== undefined && String(studentNumber).trim()) return `number:${studentNumber}`;
  const studentName = seat?.student_name ?? seat?.studentName;
  return studentName ? `name:${studentName}` : '';
};

const isAvailableSeatCell = (row, col, rows, cols, grid) => (
  row >= 1 && row <= rows && col >= 1 && col <= cols &&
  (!Array.isArray(grid) || grid[row - 1]?.[col - 1] !== false)
);

const getInvalidSeatAssignments = (seatList, currentLayout, grid) => (
  seatList.filter((seat) => {
    if (!hasStudentAssignment(seat)) return false;
    const row = toSeatCoordinate(seat.row_number ?? seat.rowNumber);
    const col = toSeatCoordinate(seat.col_number ?? seat.colNumber);
    return !isAvailableSeatCell(row, col, currentLayout.rows, currentLayout.cols, grid);
  })
);

const toSeatSavePayload = (seat) => ({
  row_number: toSeatCoordinate(seat?.row_number ?? seat?.rowNumber),
  col_number: toSeatCoordinate(seat?.col_number ?? seat?.colNumber),
  student_id: seat?.student_id ?? seat?.studentId ?? null,
  student_name: seat?.student_name ?? seat?.studentName ?? null,
  student_number: seat?.student_number ?? seat?.studentNumber ?? null,
  seat_type: seat?.seat_type ?? seat?.seatType ?? null,
  is_group_leader: seat?.is_group_leader ?? seat?.isGroupLeader ?? false,
  notes: seat?.notes ?? null
});

// 可视化表格预览选择器组件（类似Word插入表格）
const GridSelector = ({ onSelect, maxRows = 10, maxCols = 10 }) => {
  const [hoverCell, setHoverCell] = useState({ row: 0, col: 0 });

  const [selectedCell, setSelectedCell] = useState({ row: 0, col: 0 });



  const handleCellHover = (row, col) => {

    setHoverCell({ row, col });

  };



  const handleCellClick = (row, col) => {

    // 点击时更新选中状态

    setSelectedCell({ row, col });

  };



  const handleMouseLeave = () => {

    // 鼠标离开网格区域时，清空悬停状态

    setHoverCell({ row: 0, col: 0 });

  };



  const handleConfirm = () => {

    if (selectedCell.row > 0 && selectedCell.col > 0) {

      onSelect(selectedCell.row, selectedCell.col);

    } else if (hoverCell.row > 0 && hoverCell.col > 0) {

      onSelect(hoverCell.row, hoverCell.col);

    }

  };



  // 显示优先级：悬停中 > 已点击 > 默认

  // 当鼠标悬停时，只显示悬停区域；没有悬停时，显示点击区域

  const displayCell = hoverCell.row > 0 ? hoverCell : selectedCell;



  return (

    <div style={{ padding: '16px', backgroundColor: '#fff', borderRadius: '8px' }}>

      <div style={{ marginBottom: 12, textAlign: 'center', fontSize: '16px', color: '#1890ff', fontWeight: 600 }}>

        {displayCell.row > 0 && displayCell.col > 0 

          ? `${displayCell.row} 行 × ${displayCell.col} 列` 

          : '请选择行列数'}

        {selectedCell.row > 0 && hoverCell.row === 0 && (

          <span style={{ fontSize: '12px', color: '#52c41a', marginLeft: '8px' }}>✓ 已选择</span>

        )}

      </div>

      

      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 16 }}>

        <div 

          style={{ display: 'inline-block', backgroundColor: '#fafafa', padding: '4px', borderRadius: '4px' }}

          onMouseLeave={handleMouseLeave}

        >

          {Array.from({ length: maxRows }, (_, rowIndex) => (

            <div key={rowIndex} style={{ display: 'flex' }}>

              {Array.from({ length: maxCols }, (_, colIndex) => {

                const row = rowIndex + 1;

                const col = colIndex + 1;

                

                // 只显示一个状态：悬停优先，没悬停就显示点击

                const isInDisplay = row <= displayCell.row && col <= displayCell.col;

                const isHovering = hoverCell.row > 0; // 是否正在悬停

                

                return (

                  <div

                    key={colIndex}

                    onMouseEnter={() => handleCellHover(row, col)}

                    onClick={() => handleCellClick(row, col)}

                    style={{

                      width: 20,

                      height: 20,

                      margin: 2,

                      border: isInDisplay ? '2px solid #1890ff' : '1px solid #d9d9d9',

                      backgroundColor: isInDisplay ? (isHovering ? '#1890ff' : '#69c0ff') : '#fff',

                      cursor: 'pointer',

                      transition: 'all 0.15s',

                      borderRadius: '2px'

                    }}

                  />

                );

              })}

            </div>

          ))}

        </div>

      </div>



      <div style={{ textAlign: 'center' }}>

        <Space>

          <Button

            type="primary"

            onClick={handleConfirm}

            disabled={displayCell.row === 0 || displayCell.col === 0}

          >

            确定

          </Button>

          <Button onClick={() => {

            setSelectedCell({ row: 0, col: 0 });

            setHoverCell({ row: 0, col: 0 });

          }}>

            重置

          </Button>

        </Space>

      </div>



      <Alert

        message="使用提示"

        description="鼠标悬停预览，点击锁定区域（深蓝），可多次点击调整，最后点击【确定】按钮应用"

        type="info"

        showIcon

        style={{ marginTop: 16, fontSize: '12px' }}

      />

    </div>

  );

};



// 自由布局设计器组件 - 可以点击单个格子标记座位/过道

const LayoutDesigner = ({ onConfirm, initialRows = 8, initialCols = 8, initialGrid = null }) => {
  const [rows, setRows] = useState(initialRows);
  const [cols, setCols] = useState(initialCols);
  const [grid, setGrid] = useState(() => {
    return normalizeCustomGrid(initialGrid, initialRows, initialCols)
      || Array(initialRows).fill(null).map(() => Array(initialCols).fill(true));
  });

  const [drawMode, setDrawMode] = useState('seat'); // 'seat' 或 'aisle'

  const [isDrawing, setIsDrawing] = useState(false);



  // 更新网格大小

  const updateGridSize = (newRows, newCols) => {

    const newGrid = Array(newRows).fill(null).map((_, rowIdx) => 

      Array(newCols).fill(null).map((_, colIdx) => {

        // 保留原有的数据

        if (rowIdx < grid.length && colIdx < grid[0]?.length) {

          return grid[rowIdx][colIdx];

        }

        return true; // 新增的格子默认为座位

      })

    );

    setGrid(newGrid);

    setRows(newRows);

    setCols(newCols);

  };



  // 切换单个格子的状态

  const toggleCell = (rowIdx, colIdx) => {

    const newGrid = [...grid];

    newGrid[rowIdx] = [...newGrid[rowIdx]];

    newGrid[rowIdx][colIdx] = drawMode === 'seat';

    setGrid(newGrid);

  };



  // 鼠标按下开始绘制

  const handleMouseDown = (rowIdx, colIdx) => {

    setIsDrawing(true);

    toggleCell(rowIdx, colIdx);

  };



  // 鼠标移动时绘制

  const handleMouseEnter = (rowIdx, colIdx) => {

    if (isDrawing) {

      toggleCell(rowIdx, colIdx);

    }

  };



  // 鼠标释放停止绘制

  const handleMouseUp = () => {

    setIsDrawing(false);

  };



  // 统计座位数和过道数

  const seatCount = grid.flat().filter(cell => cell).length;

  const aisleCount = grid.flat().filter(cell => !cell).length;



  // 快速操作

  const fillAll = () => setGrid(Array(rows).fill(null).map(() => Array(cols).fill(true)));

  const clearAll = () => setGrid(Array(rows).fill(null).map(() => Array(cols).fill(false)));



  const handleConfirm = () => {

    // 分析过道位置

    const aisleColumns = [];

    for (let col = 0; col < cols - 1; col++) {

      let isAisleCol = true;

      for (let row = 0; row < rows; row++) {

        if (grid[row][col]) {

          isAisleCol = false;

          break;

        }

      }

      if (isAisleCol) {

        aisleColumns.push(col + 1);

      }

    }



    onConfirm({

      rows,

      cols,

      grid,

      aislePositions: aisleColumns

    });

  };



  return (

    <div style={{ padding: '16px' }}>

      {/* 工具栏 */}

      <Card size="small" style={{ marginBottom: 16 }}>

        <Space direction="vertical" style={{ width: '100%' }}>

          <div>

            <Text strong>网格尺寸：</Text>

            <Space>

              <InputNumber 

                size="small" 

                min={1} 

                max={20} 

                value={rows} 

                onChange={(val) => updateGridSize(val, cols)}

                addonBefore="行"

                style={{ width: 100 }}

              />

              <InputNumber 

                size="small" 

                min={1} 

                max={20} 

                value={cols} 

                onChange={(val) => updateGridSize(rows, val)}

                addonBefore="列"

                style={{ width: 100 }}

              />

            </Space>

          </div>



          <div>

            <Text strong>绘制模式：</Text>

            <Radio.Group value={drawMode} onChange={e => setDrawMode(e.target.value)} size="small">

              <Radio.Button value="seat">

                <span style={{ color: '#1890ff' }}>● 座位</span>

              </Radio.Button>

              <Radio.Button value="aisle">

                <span style={{ color: '#bbb' }}>○ 过道</span>

              </Radio.Button>

            </Radio.Group>

          </div>



          <div>

            <Space>

              <Button size="small" onClick={fillAll}>全部填充</Button>

              <Button size="small" onClick={clearAll}>全部清空</Button>

              <Tag color="blue">座位: {seatCount}</Tag>

              <Tag color="default">过道: {aisleCount}</Tag>

            </Space>

          </div>

        </Space>

      </Card>



      {/* 网格设计器 */}

      <div 

        style={{ 

          display: 'flex', 

          justifyContent: 'center', 

          marginBottom: 16,

          userSelect: 'none'

        }}

        onMouseUp={handleMouseUp}

        onMouseLeave={handleMouseUp}

      >

        <div style={{ display: 'inline-block', backgroundColor: '#fafafa', padding: '8px', borderRadius: '8px' }}>

          {grid.map((row, rowIdx) => (

            <div key={rowIdx} style={{ display: 'flex' }}>

              {row.map((isSeat, colIdx) => (

                <div

                  key={colIdx}

                  onMouseDown={() => handleMouseDown(rowIdx, colIdx)}

                  onMouseEnter={() => handleMouseEnter(rowIdx, colIdx)}

                  style={{

                    width: 28,

                    height: 28,

                    margin: 2,

                    border: isSeat ? '2px solid #1890ff' : '1px dashed #d9d9d9',

                    backgroundColor: isSeat ? '#e6f7ff' : '#fff',

                    cursor: 'pointer',

                    borderRadius: '4px',

                    display: 'flex',

                    alignItems: 'center',

                    justifyContent: 'center',

                    fontSize: '10px',

                    color: '#999',

                    transition: 'all 0.1s'

                  }}

                >

                  {isSeat ? '●' : ''}

                </div>

              ))}

            </div>

          ))}

        </div>

      </div>



      <Alert

        message="使用提示"

        description="选择绘制模式（座位/过道），然后点击或拖动鼠标在网格上绘制。蓝色实线=座位，灰色虚线=过道"

        type="info"

        showIcon

        style={{ marginBottom: 16 }}

      />



      <div style={{ textAlign: 'center' }}>

        <Space>

          <Button type="primary" onClick={handleConfirm}>

            确定并应用布局

          </Button>

          <Button onClick={fillAll}>重置</Button>

        </Space>

      </div>

    </div>

  );

};



// 座位布局模板数据

const layoutTemplates = [

  {

    id: 'single-aisle',

    name: '单人单桌+过道',

    icon: <BorderOutlined />,

    description: '每个座位独立，每列都有过道',

    preview: '▢ | ▢ | ▢ | ▢',

    config: {

      seatGroups: [{ type: 'single', count: 'all' }],

      aislePositions: 'all' // 特殊标记，表示所有列后都有过道

    }

  },

  {

    id: 'double-aisle',

    name: '双人桌+过道',

    icon: <LayoutOutlined />,

    description: '双人桌，每2列一个过道',

    preview: '▢▢ | ▢▢ | ▢▢',

    config: {

      seatGroups: [{ type: 'double', count: 'all' }],

      aislePositions: [2, 4, 6]

    }

  },

  {

    id: 'quad',

    name: '四人小组+过道',

    icon: <AppstoreOutlined />,

    description: '四人一组围坐，组间有过道',

    preview: '▢▢▢▢ | ▢▢▢▢',

    config: {

      seatGroups: [{ type: 'quad', count: 'all' }],

      aislePositions: [4]

    }

  },

  {

    id: 'layout-1-3-3-1',

    name: '1-3-3-1布局',

    icon: <LayoutOutlined />,

    description: '左右单人，中间两组三人座',

    preview: '▢ | ▢▢▢ | ▢▢▢ | ▢',

    config: {

      seatGroups: [

        { type: 'single', count: 1 },

        { type: 'triple', count: 3 },

        { type: 'triple', count: 3 },

        { type: 'single', count: 1 }

      ],

      aislePositions: [1, 4, 7],

      columnPattern: [1, 3, 3, 1], // 每组的座位数

      totalColsPerRow: 8, // 每行总座位数

      layoutMode: 'pattern'

    }

  },

  {

    id: 'layout-1-2-1-2',

    name: '1-2-1-2布局',

    icon: <LayoutOutlined />,

    description: '单人和双人交替排列',

    preview: '▢ | ▢▢ | ▢ | ▢▢',

    config: {

      seatGroups: [

        { type: 'single', count: 1 },

        { type: 'double', count: 2 },

        { type: 'single', count: 1 },

        { type: 'double', count: 2 }

      ],

      aislePositions: [1, 3, 4],

      // 明确的列布局模式，后端应该循环保持这个模式

      columnPattern: [1, 2, 1, 2], // 每列的座位数

      totalColsPerRow: 6, // 每行总座位数

      layoutMode: 'pattern' // 标记这是一个需要保持模式的布局

    }

  },

  {

    id: 'mixed-2-4-2',

    name: '2-4-2布局',

    icon: <LayoutOutlined />,

    description: '两边双人桌，中间四人桌',

    preview: '▢▢ | ▢▢▢▢ | ▢▢',

    config: {

      seatGroups: [

        { type: 'double', cols: [1, 2] },

        { type: 'quad', cols: [3, 4, 5, 6] },

        { type: 'double', cols: [7, 8] }

      ],

      aislePositions: [2, 6]

    }

  },

  {

    id: 'custom',

    name: '自由组合',

    icon: <TableOutlined />,

    description: '输入数字组合，如：1-3-2',

    preview: '自定义',

    config: {

      seatGroups: [],

      aislePositions: []

    }

  }

];



const SeatManagement = ({ classId, classInfo }) => {

  const [loading, setLoading] = useState(false);
  const [seats, setSeats] = useState([]);
  const seatsRef = useRef([]);
  const draggedSeatRef = useRef(null);
  const dragDropHandledRef = useRef(false);
  const pendingEmptySeatMovesRef = useRef([]);
  const [layout, setLayout] = useState({ rows: 0, cols: 0, podiumPosition: 'top' });
  const [layoutForm] = Form.useForm();

  const fileInputRef = useRef(null);
  const [draggedSeat, setDraggedSeat] = useState(null);
  const [layoutMode, setLayoutMode] = useState('single'); // 'single' 或 'double'
  const [aislePositions, setAislePositions] = useState([]); // 过道位置 [3, 6] 表示第3列和第6列后有过道
  const [customGrid, setCustomGrid] = useState(null);
  

  // 新增状态

  const [gridSelectorVisible, setGridSelectorVisible] = useState(false);

  const [templateSelectorVisible, setTemplateSelectorVisible] = useState(false);

  const [selectedTemplate, setSelectedTemplate] = useState(null);

  const [customLayoutMode, setCustomLayoutMode] = useState(false);

  const [layoutDesignerVisible, setLayoutDesignerVisible] = useState(false); // 布局设计器
  const [helpVisible, setHelpVisible] = useState(false); // 使用说明可见性
  const [layoutInfoVisible, setLayoutInfoVisible] = useState(false); // 座位布局信息可见性

  const replaceSeats = (nextSeats) => {
    seatsRef.current = nextSeats;
    setSeats(nextSeats);
  };

  const applyPendingEmptySeatMoves = (seatList) => {
    let nextSeats = seatList.map((seat) => ({ ...seat }));
    pendingEmptySeatMovesRef.current.forEach((move) => {
      let hasTargetRecord = false;
      nextSeats = nextSeats.map((seat) => {
        const row = toSeatCoordinate(seat.row_number ?? seat.rowNumber);
        const col = toSeatCoordinate(seat.col_number ?? seat.colNumber);
        let nextSeat = seat;

        if (getSeatStudentKey(seat) === move.studentKey) {
          nextSeat = {
            ...nextSeat,
            student_id: null,
            studentId: null,
            student_name: null,
            studentName: null,
            student_number: null,
            studentNumber: null
          };
        }
        if (row === move.targetRow && col === move.targetCol) {
          hasTargetRecord = true;
          nextSeat = { ...nextSeat, ...move.student };
        }
        return nextSeat;
      });

      if (!hasTargetRecord) {
        nextSeats.push({
          row_number: move.targetRow,
          col_number: move.targetCol,
          ...move.student,
          seat_type: move.seatType,
          is_group_leader: false,
          notes: null
        });
      }
    });
    return nextSeats;
  };


  useEffect(() => {

    if (classId) {

      fetchSeats();

    }

    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [classId]);



  // 获取座位安排

  const fetchSeats = async () => {

    try {

      setLoading(true);

      const token = localStorage.getItem('token');

      const response = await axios.get(`/api/v2/seats/${classId}`, {

        headers: { Authorization: `Bearer ${token}` }

      });

      if (response.data.success) {
        pendingEmptySeatMovesRef.current = [];
        const layoutData = response.data.data.layout;
        replaceSeats(response.data.data.seats || []);
        const podiumPos = layoutData.podiumPosition || layoutData.podium_position || 'top';
        setLayout({

          rows: layoutData.rows || 0,

          cols: layoutData.cols || 0,

          podiumPosition: podiumPos

        });

        

        // 恢复布局配置

        if (layoutData.layoutMode) {

          setLayoutMode(layoutData.layoutMode);

        }

        if (layoutData.aislePositions) {
          setAislePositions(layoutData.aislePositions);
        }
        setCustomGrid(normalizeCustomGrid(layoutData.customGrid, layoutData.rows, layoutData.cols));
        

        // 如果有座位数据，更新表单

        if (layoutData.rows > 0) {

          layoutForm.setFieldsValue({

            rows: layoutData.rows,

            cols: layoutData.cols,

            seatType: layoutData.layoutMode || 'single',

            podiumPosition: podiumPos

          });

        }

      }

    } catch (error) {

      console.error('获取座位安排失败:', error);

      message.error('获取座位安排失败');

    } finally {

      setLoading(false);

    }

  };



  // 随机排座

  const handleRandomArrange = async () => {

    try {

      const values = await layoutForm.validateFields();

      setLoading(true);



      // 如果过道位置是 'all'，生成所有列的过道

      let finalAislePositions = aislePositions;

      if (aislePositions === 'all') {

        const cols = values.cols || 8;

        const allAisles = Array.from({ length: cols - 1 }, (_, i) => i + 1);

        setAislePositions(allAisles);

        finalAislePositions = allAisles;

      }



      // 构建完整的排座配置

      const seatConfig = {

        ...values,

        aislePositions: Array.isArray(finalAislePositions) ? finalAislePositions : [],
        customGrid: normalizeCustomGrid(customGrid, values.rows, values.cols),
        layoutTemplate: selectedTemplate?.id || null,

        customLayout: values.customLayout || null,

        // 布局模式信息（重要：用于保持列的布局模式）

        columnPattern: selectedTemplate?.config?.columnPattern || null,

        totalColsPerRow: selectedTemplate?.config?.totalColsPerRow || null,

        layoutMode: selectedTemplate?.config?.layoutMode || 'normal',

        // 智能排座选项

        genderArrangement: values.genderArrangement || 'none',

        gradeArrangement: values.gradeArrangement || 'none',

        heightArrangement: values.heightArrangement || 'none',

        numberArrangement: values.numberArrangement || 'none'

      };



      console.log('发送排座配置:', seatConfig); // 调试用



      const token = localStorage.getItem('token');

      const response = await axios.post(`/api/v2/seats/random/${classId}`, seatConfig, {

        headers: { Authorization: `Bearer ${token}` }

      });



      if (response.data.success) {

        message.success('随机排座成功');

        setLayoutMode(values.seatType);

        fetchSeats();

      }

    } catch (error) {

      console.error('随机排座失败:', error);

      message.error(error.response?.data?.message || '随机排座失败');

    } finally {

      setLoading(false);

    }

  };



  // 保存当前座位安排
  const handleSaveSeats = async () => {
    try {
      const seatsToSave = applyPendingEmptySeatMoves(
        seatsRef.current.map(toSeatSavePayload)
      );
      const invalidAssignments = getInvalidSeatAssignments(seatsToSave, layout, customGrid);
      if (invalidAssignments.length > 0) {
        const locations = invalidAssignments
          .slice(0, 3)
          .map((seat) => `${seat.row_number ?? seat.rowNumber}-${seat.col_number ?? seat.colNumber}`)
          .join('、');
        message.error(`有 ${invalidAssignments.length} 名学生位于非座位格或布局外（${locations}），请先拖到有效空位后再保存`);
        return;
      }

      setLoading(true);
      const token = localStorage.getItem('token');
      

      // 准备布局配置数据

      const layoutData = {

        rows: layout.rows,

        cols: layout.cols,

        layoutMode: layoutMode,
        aislePositions: aislePositions,
        customGrid: normalizeCustomGrid(customGrid, layout.rows, layout.cols),
        templateId: selectedTemplate?.id || null,
        notes: null,

        podiumPosition: layout.podiumPosition || 'top'

      };

      

      const response = await axios.post(`/api/v2/seats/batch/${classId}`, {
        seats: seatsToSave,
        layout: layoutData
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (!response.data?.success) {
        throw new Error(response.data?.message || '保存座位失败');
      }
      if (Array.isArray(response.data?.data?.seats)) {
        pendingEmptySeatMovesRef.current = [];
        replaceSeats(response.data.data.seats);
      }
      message.success('座位保存成功');
    } catch (error) {
      console.error('保存座位失败:', error);
      message.error(error.response?.data?.message || error.message || '保存座位失败');
    } finally {

      setLoading(false);

    }

  };



  // 清空座位

  const handleClearSeats = async () => {

    try {

      setLoading(true);

      const token = localStorage.getItem('token');

      await axios.delete(`/api/v2/seats/${classId}`, {

        headers: { Authorization: `Bearer ${token}` }

      });



      message.success('座位已清空');

      fetchSeats();

    } catch (error) {

      console.error('清空座位失败:', error);

      message.error('清空座位失败');

    } finally {

      setLoading(false);

    }

  };



  // 保留浏览器原生拖动效果，同时允许目标格在数据库中尚无空座位记录。
  const moveDraggedStudent = (activeDraggedSeat, targetRow, targetCol, targetSeat) => {
    if (!activeDraggedSeat) {
      message.warning('未读取到拖拽学生，请重新拖动一次');
      return;
    }
    if (!isAvailableSeatCell(targetRow, targetCol, layout.rows, layout.cols, customGrid)) {
      message.warning('不能将学生放到过道或布局外的位置');
      return;
    }

    const sourceRow = toSeatCoordinate(activeDraggedSeat.row_number ?? activeDraggedSeat.rowNumber);
    const sourceCol = toSeatCoordinate(activeDraggedSeat.col_number ?? activeDraggedSeat.colNumber);
    if (!sourceRow || !sourceCol || (sourceRow === targetRow && sourceCol === targetCol)) return;

    const targetStudent = targetSeat
      ? {
          student_id: targetSeat.student_id ?? targetSeat.studentId ?? null,
          student_name: targetSeat.student_name ?? targetSeat.studentName ?? null,
          student_number: targetSeat.student_number ?? targetSeat.studentNumber ?? null
        }
      : { student_id: null, student_name: null, student_number: null };
    const activeStudent = {
      student_id: activeDraggedSeat.student_id ?? activeDraggedSeat.studentId ?? null,
      student_name: activeDraggedSeat.student_name ?? activeDraggedSeat.studentName ?? null,
      student_number: activeDraggedSeat.student_number ?? activeDraggedSeat.studentNumber ?? null
    };
    const studentKey = getSeatStudentKey(activeStudent);
    pendingEmptySeatMovesRef.current = pendingEmptySeatMovesRef.current.filter((move) => (
      move.studentKey !== studentKey
    ));
    if (!hasStudentAssignment(targetSeat)) {
      pendingEmptySeatMovesRef.current.push({
        studentKey,
        student: activeStudent,
        targetRow,
        targetCol,
        seatType: activeDraggedSeat.seat_type ?? activeDraggedSeat.seatType ?? layoutMode
      });
    }
    let hasTargetRecord = false;

    const newSeats = seatsRef.current.map((seat) => {
      const row = toSeatCoordinate(seat.row_number ?? seat.rowNumber);
      const col = toSeatCoordinate(seat.col_number ?? seat.colNumber);
      if (row === sourceRow && col === sourceCol) return { ...seat, ...targetStudent };
      if (row === targetRow && col === targetCol) {
        hasTargetRecord = true;
        return {
          ...seat,
          ...activeStudent
        };
      }
      return seat;
    });

    if (!hasTargetRecord) {
      newSeats.push({
        row_number: targetRow,
        col_number: targetCol,
        ...activeStudent,
        seat_type: activeDraggedSeat.seat_type ?? activeDraggedSeat.seatType ?? layoutMode,
        is_group_leader: false,
        notes: null
      });
    }

    dragDropHandledRef.current = true;
    replaceSeats(newSeats);
    draggedSeatRef.current = null;
    setDraggedSeat(null);
    message.success('座位已交换，请点击“保存座位安排”按钮保存更改');
  };

  const handleDragStart = (event, seat) => {
    dragDropHandledRef.current = false;
    draggedSeatRef.current = seat;
    setDraggedSeat(seat);
    event.dataTransfer.effectAllowed = 'move';
    event.dataTransfer.setData('text/html', event.currentTarget.innerHTML);
    event.currentTarget.style.opacity = '0.4';
  };

  const handleDragEnd = (event) => {
    event.currentTarget.style.opacity = '1';
    const activeDraggedSeat = draggedSeatRef.current || draggedSeat;
    if (!dragDropHandledRef.current && activeDraggedSeat && event.clientX > 0 && event.clientY > 0) {
      const elementAtRelease = document.elementFromPoint(event.clientX, event.clientY);
      const targetCell = elementAtRelease?.closest?.('[data-seat-cell="true"]');
      if (targetCell) {
        const targetRow = toSeatCoordinate(targetCell.dataset.row);
        const targetCol = toSeatCoordinate(targetCell.dataset.col);
        const targetSeat = seatsRef.current.find((seat) => (
          toSeatCoordinate(seat.row_number ?? seat.rowNumber) === targetRow &&
          toSeatCoordinate(seat.col_number ?? seat.colNumber) === targetCol
        ));
        moveDraggedStudent(activeDraggedSeat, targetRow, targetCol, targetSeat);
      }
    }
    draggedSeatRef.current = null;
    dragDropHandledRef.current = false;
    setDraggedSeat(null);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
  };

  const handleDragEnter = (event) => {
    event.currentTarget.style.border = '2px dashed #1890ff';
  };

  const handleDragLeave = (event) => {
    event.currentTarget.style.border = '2px solid #d9d9d9';
  };

  const handleDrop = (event, targetRow, targetCol, targetSeat) => {
    event.preventDefault();
    event.stopPropagation();
    event.currentTarget.style.border = '2px solid #d9d9d9';

    const activeDraggedSeat = draggedSeatRef.current || draggedSeat;
    moveDraggedStudent(activeDraggedSeat, targetRow, targetCol, targetSeat);
  };

  const handleRemoveStudentFromSeat = (event, row, col) => {
    event?.preventDefault();
    event?.stopPropagation();
    const removedSeat = seatsRef.current.find((seat) => {
      const seatRow = toSeatCoordinate(seat.row_number ?? seat.rowNumber);
      const seatCol = toSeatCoordinate(seat.col_number ?? seat.colNumber);
      return seatRow === row && seatCol === col;
    });
    const removedStudentKey = getSeatStudentKey(removedSeat);
    if (removedStudentKey) {
      pendingEmptySeatMovesRef.current = pendingEmptySeatMovesRef.current.filter((move) => (
        move.studentKey !== removedStudentKey
      ));
    }
    const nextSeats = seatsRef.current.map((seat) => {
      const seatRow = toSeatCoordinate(seat.row_number ?? seat.rowNumber);
      const seatCol = toSeatCoordinate(seat.col_number ?? seat.colNumber);
      if (seatRow !== row || seatCol !== col) return seat;
      return {
        ...seat,
        student_id: null,
        studentId: null,
        student_name: null,
        studentName: null,
        student_number: null,
        studentNumber: null
      };
    });
    replaceSeats(nextSeats);
    message.success('已从座位表移出，请点击“保存座位安排”生效');
  };

  // 导出、导入函数保持不变...
  const handleExportSeats = () => {

    if (seats.length === 0) {

      message.warning('没有座位数据可导出');

      return;

    }



    const exportData = seats.map(seat => ({

      '行号': seat.row_number,

      '列号': seat.col_number,

      '学生姓名': seat.student_name || '空座位',

      '学号': seat.student_number || '',

      '座位类型': seat.seat_type === 'single' ? '单人座' : '双人座',

      '备注': seat.notes || ''

    }));



    const worksheet = XLSX.utils.json_to_sheet(exportData);

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "座位表");

    XLSX.writeFile(workbook, `座位表-${classInfo?.name || classId}.xlsx`);

    message.success('导出成功');

  };



  const handleExportLayoutTemplate = () => {

    if (layout.rows === 0 || layout.cols === 0) {

      message.warning('请先设置座位布局');

      return;

    }



    const layoutData = [];

    const header = ['行/列'];

    for (let col = 1; col <= layout.cols; col++) {

      header.push(`第${col}列`);

    }

    layoutData.push(header);



    for (let row = 1; row <= layout.rows; row++) {

      const rowData = [`第${row}行`];

      for (let col = 1; col <= layout.cols; col++) {

        const seat = seats.find(s => s.row_number === row && s.col_number === col);

        rowData.push(seat?.student_name || '');

      }

      layoutData.push(rowData);

    }



    const worksheet = XLSX.utils.aoa_to_sheet(layoutData);

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "座位布局");

    XLSX.writeFile(workbook, `座位布局-${classInfo?.name || classId}.xlsx`);

    message.success('导出成功');

  };



  const handleImportSeats = (event) => {

    const file = event.target.files[0];

    if (!file) return;



    const reader = new FileReader();

    reader.onload = async (e) => {

      try {

        const data = new Uint8Array(e.target.result);

        const workbook = XLSX.read(data, { type: 'array' });

        const worksheet = workbook.Sheets[workbook.SheetNames[0]];

        const jsonData = XLSX.utils.sheet_to_json(worksheet);



        if (jsonData.length === 0) {

          message.error('Excel文件为空');

          return;

        }



        const seatData = jsonData.map(row => ({
          row_number: toSeatCoordinate(row['行号']),
          col_number: toSeatCoordinate(row['列号']),
          student_name: row['学生姓名'] === '空座位' ? null : row['学生姓名'],

          student_number: row['学号'] || null,

          seat_type: row['座位类型'] === '双人座' ? 'double' : 'single',

          notes: row['备注'] || null

        })).filter(s => s.row_number && s.col_number);



        if (seatData.length === 0) {
          message.error('Excel数据格式不正确');
          return;
        }

        const duplicateCells = new Set();
        const hasDuplicateCell = seatData.some((seat) => {
          const key = `${seat.row_number}:${seat.col_number}`;
          if (duplicateCells.has(key)) return true;
          duplicateCells.add(key);
          return false;
        });
        if (hasDuplicateCell) {
          message.error('Excel中存在重复的行列坐标，请修正后再导入');
          return;
        }

        const importedRows = Math.max(...seatData.map((seat) => seat.row_number));
        const importedCols = Math.max(...seatData.map((seat) => seat.col_number));

        const token = localStorage.getItem('token');
        await axios.post(`/api/v2/seats/batch/${classId}`, {
          seats: seatData,
          layout: {
            rows: importedRows,
            cols: importedCols,
            layoutMode: 'single',
            aislePositions: [],
            podiumPosition: 'top'
          }
        }, {

          headers: { Authorization: `Bearer ${token}` }

        });



        message.success(`成功导入 ${seatData.length} 个座位`);

        fetchSeats();

      } catch (error) {

        console.error('导入失败:', error);

        message.error('导入失败：' + (error.response?.data?.message || error.message));

      }

    };

    reader.readAsArrayBuffer(file);

    event.target.value = '';

  };



  // 列间过道只影响展示间距，不改变任何学生的行、列坐标。
  // "all" 是旧模板的兼容值；用户点击任一列间按钮时，将其展开成明确的列号配置。
  const getEditableAislePositions = () => {
    if (aislePositions === 'all') {
      return Array.from({ length: Math.max(layout.cols - 1, 0) }, (_, index) => index + 1);
    }

    return Array.isArray(aislePositions)
      ? [...new Set(aislePositions.map(Number).filter((position) => (
        Number.isInteger(position) && position >= 1 && position < layout.cols
      )))].sort((left, right) => left - right)
      : [];
  };

  const toggleAisleAfterColumn = (column) => {
    if (!Number.isInteger(column) || column < 1 || column >= layout.cols) return;

    const currentPositions = getEditableAislePositions();
    const nextPositions = currentPositions.includes(column)
      ? currentPositions.filter((position) => position !== column)
      : [...currentPositions, column].sort((left, right) => left - right);

    setAislePositions(nextPositions);
  };

  // 渲染座位表格（支持拖拽和过道）
  const renderSeatGrid = () => {

    if (seats.length === 0) {

      return (

        <div style={{ textAlign: 'center', padding: '60px 0', color: '#999' }}>

          <TableOutlined style={{ fontSize: 48, marginBottom: 16 }} />

          <p style={{ fontSize: 16 }}>暂无座位安排</p>

          <p style={{ fontSize: 14 }}>先设置排列组合，然后点击"开始随机排座"</p>

        </div>

      );

    }



    const rows = [];

    

    // 生成列号标题行

    const colHeaders = [];

    colHeaders.push(

      <div key="corner" style={{ width: 50, minWidth: 50, marginRight: 8 }} />

    );

    

    for (let col = 1; col <= layout.cols; col++) {

      const isSecondSeatOfPair = layoutMode === 'double' && col % 2 === 0;

      if (isSecondSeatOfPair) continue;

      

      // 判断这个列后是否有过道

      let hasAisleAfter = false;

      if (aislePositions === 'all') {

        hasAisleAfter = col < layout.cols;

      } else if (Array.isArray(aislePositions)) {

        if (layoutMode === 'double') {

          hasAisleAfter = aislePositions.includes(col) || aislePositions.includes(col + 1);

        } else {

          hasAisleAfter = aislePositions.includes(col);

        }

      }

      

      const colWidth = layoutMode === 'double' ? 208 : 120;
      const aisleBoundary = layoutMode === 'double' ? Math.min(col + 1, layout.cols) : col;
      const canToggleAisle = aisleBoundary < layout.cols;
      

      colHeaders.push(

        <div

          key={`col-header-${col}`}

          style={{

            minWidth: colWidth,

            textAlign: 'center',

            fontWeight: 'bold',

            fontSize: 12,

            color: '#1890ff',

            marginBottom: 8,
            marginRight: hasAisleAfter ? '60px' : '12px',
            position: 'relative'
          }}

        >

          第{col}{layoutMode === 'double' && col < layout.cols ? `-${col + 1}` : ''}列
          {canToggleAisle && (
            <Button
              type={hasAisleAfter ? 'primary' : 'text'}
              size="small"
              title={hasAisleAfter ? `移除第${aisleBoundary}列后的过道` : `在第${aisleBoundary}列和第${aisleBoundary + 1}列之间插入过道`}
              aria-label={hasAisleAfter ? `移除第${aisleBoundary}列后的过道` : `在第${aisleBoundary}列和第${aisleBoundary + 1}列之间插入过道`}
              onClick={() => toggleAisleAfterColumn(aisleBoundary)}
              style={{
                position: 'absolute',
                top: -6,
                right: hasAisleAfter ? -48 : -18,
                zIndex: 2,
                minWidth: hasAisleAfter ? 44 : 22,
                height: 22,
                padding: hasAisleAfter ? '0 6px' : 0,
                borderRadius: 11,
                fontSize: hasAisleAfter ? 11 : 16,
                lineHeight: '20px'
              }}
            >
              {hasAisleAfter ? '过道' : '+'}
            </Button>
          )}
        </div>

      );

    }

    

    for (let row = 1; row <= layout.rows; row++) {
      const cols = [];
      
      for (let col = 1; col <= layout.cols; col++) {
        const isCustomAisleCell = Array.isArray(customGrid) && customGrid[row - 1]?.[col - 1] === false;
        if (isCustomAisleCell) {
          cols.push(
            <div
              key={`${row}-${col}-custom-aisle`}
              style={{
                minWidth: 40,
                minHeight: 80,
                marginRight: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#52c41a',
                fontSize: 12,
                fontWeight: 'bold',
                borderLeft: '3px dashed #52c41a',
                borderRight: '3px dashed #52c41a',
                backgroundColor: 'rgba(82, 196, 26, 0.08)'
              }}
            >
              <span style={{ writingMode: 'vertical-rl', letterSpacing: '4px' }}>过道</span>
            </div>
          );
          continue;
        }
        const seat = seats.find(s => s.row_number === row && s.col_number === col);
        

        // 判断是否是双人座的第二个位置（需要跳过渲染）

        const isSecondSeatOfPair = layoutMode === 'double' && col % 2 === 0;

        

        if (isSecondSeatOfPair) {

          continue; // 双人座模式下，偶数列由奇数列的座位覆盖

        }



        // 判断这个座位后面是否有过道

        // 双人座模式：判断当前列或下一列（同桌列）后是否有过道

        // 单人座模式：判断当前列后是否有过道

        let hasAisleAfter = false;

        if (aislePositions === 'all') {

          // 所有列后都有过道（除了最后一列）

          hasAisleAfter = col < layout.cols;

        } else if (Array.isArray(aislePositions)) {

          if (layoutMode === 'double') {

            // 双人座：检查当前列和下一列后是否有过道

            hasAisleAfter = aislePositions.includes(col) || aislePositions.includes(col + 1);

          } else {

            hasAisleAfter = aislePositions.includes(col);

          }

        }

        

        // 双人座模式：获取同桌的座位

        let deskmate = null;

        if (layoutMode === 'double' && col < layout.cols) {

          deskmate = seats.find(s => s.row_number === row && s.col_number === col + 1);

        }



        cols.push(

          <div

            key={`${row}-${col}`}

            style={{

              display: 'flex',

              gap: layoutMode === 'double' ? '4px' : '0',

              marginRight: hasAisleAfter ? '60px' : '0', // 增加过道间距

              position: 'relative'

            }}

          >

            {/* 主座位 */}
            <div
              data-seat-cell="true"
              data-row={row}
              data-col={col}
              draggable={Boolean(seat?.student_name)}
              onDragStart={(event) => seat?.student_name && handleDragStart(event, seat)}
              onDragEnd={handleDragEnd}
              onDragOver={handleDragOver}
              onDragEnter={handleDragEnter}
              onDragLeave={handleDragLeave}
              onDrop={(event) => handleDrop(event, row, col, seat)}
              style={{
                border: '2px solid #d9d9d9',
                borderRadius: 8,

                padding: 12,

                minHeight: 80,

                minWidth: layoutMode === 'double' ? '100px' : '120px',

                display: 'flex',

                flexDirection: 'column',

                justifyContent: 'center',

                alignItems: 'center',

                backgroundColor: seat?.student_name ? '#f0f5ff' : '#fafafa',
                cursor: seat?.student_name ? 'move' : 'default',
                userSelect: 'none',
                WebkitUserSelect: 'none',
                transition: 'all 0.3s',
                position: 'relative'

              }}

              onMouseEnter={(e) => {

                if (seat?.student_name) {

                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(24,144,255,0.3)';

                  e.currentTarget.style.transform = 'translateY(-2px)';

                }

              }}

              onMouseLeave={(e) => {

                e.currentTarget.style.boxShadow = 'none';

                e.currentTarget.style.transform = 'translateY(0)';

              }}

            >

              {seat?.student_name ? (

                <>

                  <div style={{ fontWeight: 'bold', fontSize: 15, marginBottom: 4, textAlign: 'center' }}>

                    {seat.student_name}

                  </div>

                  {seat.student_number && (

                    <div style={{ fontSize: 11, color: '#666' }}>

                      {seat.student_number}

                    </div>

                  )}

                </>

              ) : (

                <div style={{ color: '#999', fontSize: 13 }}>空</div>

              )}

              <div style={{ position: 'absolute', top: 2, right: 4, fontSize: 9, color: '#ccc' }}>

                {row}-{col}

              </div>

              {seat?.student_name && (
                <SwapOutlined style={{ position: 'absolute', top: 2, left: 4, fontSize: 12, color: '#1890ff' }} />
              )}
              {seat?.student_name && (
                <Popconfirm
                  title={`将“${seat.student_name}”移出座位表？`}
                  description="仅清空该座位，不会删除学生档案。"
                  okText="移出"
                  cancelText="取消"
                  onConfirm={() => handleRemoveStudentFromSeat(null, row, col)}
                >
                  <Button
                    type="text"
                    danger
                    size="small"
                    icon={<DeleteOutlined />}
                    title="移出座位表"
                    onMouseDown={(event) => event.stopPropagation()}
                    onPointerDown={(event) => event.stopPropagation()}
                    onClick={(event) => event.stopPropagation()}
                    style={{ position: 'absolute', right: 1, bottom: 0, zIndex: 2 }}
                  />
                </Popconfirm>
              )}
            </div>


            {/* 双人座：同桌 */}

            {layoutMode === 'double' && deskmate && (
              <div
                data-seat-cell="true"
                data-row={row}
                data-col={col + 1}
                draggable={Boolean(deskmate?.student_name)}
                onDragStart={(event) => deskmate?.student_name && handleDragStart(event, deskmate)}
                onDragEnd={handleDragEnd}
                onDragOver={handleDragOver}
                onDragEnter={handleDragEnter}
                onDragLeave={handleDragLeave}
                onDrop={(event) => handleDrop(event, row, col + 1, deskmate)}
                style={{
                  border: '2px solid #d9d9d9',
                  borderRadius: 8,

                  padding: 12,

                  minHeight: 80,

                  minWidth: '100px',

                  display: 'flex',

                  flexDirection: 'column',

                  justifyContent: 'center',

                  alignItems: 'center',

                  backgroundColor: deskmate?.student_name ? '#e6f7ff' : '#fafafa',
                  cursor: deskmate?.student_name ? 'move' : 'default',
                  userSelect: 'none',
                  WebkitUserSelect: 'none',
                  transition: 'all 0.3s',
                  position: 'relative'

                }}

                onMouseEnter={(e) => {

                  if (deskmate?.student_name) {

                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(24,144,255,0.3)';

                    e.currentTarget.style.transform = 'translateY(-2px)';

                  }

                }}

                onMouseLeave={(e) => {

                  e.currentTarget.style.boxShadow = 'none';

                  e.currentTarget.style.transform = 'translateY(0)';

                }}

              >

                {deskmate?.student_name ? (

                  <>

                    <div style={{ fontWeight: 'bold', fontSize: 15, marginBottom: 4, textAlign: 'center' }}>

                      {deskmate.student_name}

                    </div>

                    {deskmate.student_number && (

                      <div style={{ fontSize: 11, color: '#666' }}>

                        {deskmate.student_number}

                      </div>

                    )}

                  </>

                ) : (

                  <div style={{ color: '#999', fontSize: 13 }}>空</div>

                )}

                <div style={{ position: 'absolute', top: 2, right: 4, fontSize: 9, color: '#ccc' }}>

                  {row}-{col + 1}

                </div>

                {deskmate?.student_name && (
                  <SwapOutlined style={{ position: 'absolute', top: 2, left: 4, fontSize: 12, color: '#1890ff' }} />
                )}
                {deskmate?.student_name && (
                  <Popconfirm
                    title={`将“${deskmate.student_name}”移出座位表？`}
                    description="仅清空该座位，不会删除学生档案。"
                    okText="移出"
                    cancelText="取消"
                    onConfirm={() => handleRemoveStudentFromSeat(null, row, col + 1)}
                  >
                    <Button
                      type="text"
                      danger
                      size="small"
                      icon={<DeleteOutlined />}
                    title="移出座位表"
                    onMouseDown={(event) => event.stopPropagation()}
                    onPointerDown={(event) => event.stopPropagation()}
                    onClick={(event) => event.stopPropagation()}
                      style={{ position: 'absolute', right: 1, bottom: 0, zIndex: 2 }}
                    />
                  </Popconfirm>
                )}
              </div>
            )}



            {/* 过道标识 - 增强显示且居中 */}

            {hasAisleAfter && (

              <div style={{

                position: 'absolute',

                right: -50,

                top: '50%',

                transform: 'translateY(-50%)',

                width: '40px',

                height: '100%',

                display: 'flex',

                alignItems: 'center',

                justifyContent: 'center',

                color: '#52c41a',

                fontSize: '12px',

                fontWeight: 'bold',

                borderLeft: '3px dashed #52c41a',

                borderRight: '3px dashed #52c41a',

                backgroundColor: 'rgba(82, 196, 26, 0.08)'

              }}>

                <span style={{ writingMode: 'vertical-rl', letterSpacing: '4px' }}>过道</span>

              </div>

            )}

          </div>

        );

      }

      

      rows.push(

        <div key={row} style={{ 

          display: 'flex', 

          gap: '12px',

          marginBottom: '12px',

          alignItems: 'center'

        }}>

          {/* 行号标记 */}

          <div style={{

            width: 50,

            minWidth: 50,

            textAlign: 'right',

            fontWeight: 'bold',

            fontSize: 12,

            color: '#1890ff',

            marginRight: 8

          }}>

            第{row}行

          </div>

          {cols}

        </div>

      );

    }



    const isPodiumBottom = layout.podiumPosition === 'bottom';



    return (

      <div style={{ padding: 16 }}>

        {!isPodiumBottom && (

          <div style={{ 

            textAlign: 'center', 

            marginBottom: 20, 

            fontSize: 16, 

            color: '#1890ff',

            fontWeight: 'bold',

            padding: '10px',

            backgroundColor: '#e6f7ff',

            borderRadius: 8

          }}>

            ↓ 讲台方向 ↓

          </div>

        )}

        <Alert

          message="拖拽提示"

          description="点击并拖动学生姓名卡片到另一个座位，可以交换两个学生的座位；点击列标题之间的“+”可插入过道。修改后记得点击【保存座位安排】按钮。"
          type="info"

          showIcon

          closable

          style={{ marginBottom: 16 }}

        />

        {(aislePositions === 'all' || (Array.isArray(aislePositions) && aislePositions.length > 0)) && (

          <Alert

            message="过道信息"

            description={

              aislePositions === 'all' 

                ? '当前设置：所有座位之间都有过道（绿色虚线标识）' 

                : `当前设置了 ${aislePositions.length} 个过道，位置：${aislePositions.map(p => `第${p}列后`).join('、')}（绿色虚线标识）`

            }

            type="success"

            showIcon

            closable

            style={{ marginBottom: 16 }}

          />

        )}

        

        {/* 列号标题行 */}

        <div style={{ display: 'flex', gap: '12px', marginBottom: 12, alignItems: 'center' }}>

          {colHeaders}

        </div>

        

        {/* 座位行 */}

        {rows}



        {isPodiumBottom && (

          <div style={{ 

            textAlign: 'center', 

            marginTop: 20, 

            fontSize: 16, 

            color: '#1890ff',

            fontWeight: 'bold',

            padding: '10px',

            backgroundColor: '#e6f7ff',

            borderRadius: 8

          }}>

            ↑ 讲台方向 ↑

          </div>

        )}

      </div>

    );

  };



  return (

    <div style={{ padding: '20px 0' }}>

      {/* 表格选择器模态框 */}

      <Modal

        title={

          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>

            <TableOutlined style={{ color: '#1890ff' }} />

            <span>可视化选择行列数</span>

          </div>

        }

        open={gridSelectorVisible}

        onCancel={() => setGridSelectorVisible(false)}

        footer={null}

        width={500}

        centered

      >

        <GridSelector

          onSelect={(rows, cols) => {

            layoutForm.setFieldsValue({ rows, cols });

            setGridSelectorVisible(false);

            message.success(`已选择 ${rows} 行 × ${cols} 列`);

          }}

        />

      </Modal>



      {/* 模板选择器模态框 */}

      <Modal

        title="选择座位布局模板"

        open={templateSelectorVisible}

        onCancel={() => setTemplateSelectorVisible(false)}

        footer={null}

        width={800}

      >

        <Row gutter={[16, 16]}>

          {layoutTemplates.map(template => (

            <Col xs={24} sm={12} md={8} key={template.id}>

              <Card

                hoverable

                onClick={() => {

                  setSelectedTemplate(template);

                  // 根据模板ID设置座位模式

                  // 单人单桌+过道、1-2-1-2布局使用单人模式

                  if (template.id === 'single-aisle' || template.id === 'layout-1-2-1-2' || template.id === 'layout-1-3-3-1') {

                    setLayoutMode('single');

                    layoutForm.setFieldsValue({ seatType: 'single' });

                  } else {

                    setLayoutMode('double');

                    layoutForm.setFieldsValue({ seatType: 'double' });

                  }

                  

                  // 处理过道位置

                  if (template.config.aislePositions === 'all') {

                    // 特殊情况：所有列后都有过道

                    // 需要等用户设置列数后再生成，这里先标记

                    setAislePositions('all');

                  } else {

                    setAislePositions(template.config.aislePositions);

                  }

                  

                  if (template.id === 'custom') {

                    setCustomLayoutMode(true);

                  } else {

                    setCustomLayoutMode(false);

                  }

                  

                  setTemplateSelectorVisible(false);

                  message.success(`已选择模板：${template.name}`);

                }}

                style={{

                  borderColor: selectedTemplate?.id === template.id ? '#1890ff' : '#d9d9d9',

                  borderWidth: selectedTemplate?.id === template.id ? 2 : 1

                }}

              >

                <div style={{ textAlign: 'center' }}>

                  <div style={{ fontSize: 32, marginBottom: 8 }}>

                    {template.icon}

                  </div>

                  <div style={{ fontWeight: 'bold', marginBottom: 4 }}>

                    {template.name}

                  </div>

                  <div style={{ fontSize: 12, color: '#666', marginBottom: 8 }}>

                    {template.description}

                  </div>

                  <div style={{ 

                    fontSize: 14, 

                    fontFamily: 'monospace',

                    backgroundColor: '#f5f5f5',

                    padding: '8px',

                    borderRadius: '4px'

                  }}>

                    {template.preview}

                  </div>

                </div>

              </Card>

            </Col>

          ))}

        </Row>

      </Modal>



      {/* 自由布局设计器模态框 */}

      <Modal

        title={

          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>

            <AppstoreOutlined style={{ color: '#1890ff' }} />

            <span>自由布局设计器</span>

          </div>

        }

        open={layoutDesignerVisible}
        onCancel={() => setLayoutDesignerVisible(false)}
        footer={null}
        width={800}
        centered
        destroyOnClose
      >
        <LayoutDesigner
          initialRows={layout.rows || 8}
          initialCols={layout.cols || 8}
          initialGrid={customGrid}
          onConfirm={(layoutData) => {
            layoutForm.setFieldsValue({ 
              rows: layoutData.rows, 
              cols: layoutData.cols 
            });
            setAislePositions(layoutData.aislePositions);
            setCustomGrid(normalizeCustomGrid(layoutData.grid, layoutData.rows, layoutData.cols));
            setLayout((previous) => ({
              ...previous,
              rows: layoutData.rows,
              cols: layoutData.cols
            }));
            setLayoutMode('custom');
            setLayoutDesignerVisible(false);
            message.success(`已应用自定义布局：${layoutData.rows}行×${layoutData.cols}列，${layoutData.aislePositions.length}个过道`);

          }}

        />

      </Modal>



      {/* 上方：设置区域 */}

      <Card 

        title="排列组合设置"

        bordered={false} 

        style={{ marginBottom: 16 }}

        extra={

          <Button 

            type="primary" 

            icon={<SaveOutlined />}

            onClick={handleRandomArrange}

            loading={loading}

          >

            生成座位表

          </Button>

        }

      >

        <Form

          form={layoutForm}

          layout="vertical"

          initialValues={{

            rows: 8,

            cols: 8,

            seatType: 'single'

          }}

        >

          {/* 所有设置一行显示 */}

          <Row gutter={12} align="middle">

            <Col xs={24} sm={4}>

              <Button

                type="dashed"

                icon={<TableOutlined />}

                onClick={() => setGridSelectorVisible(true)}

                block

                size="small"

              >

                可视化选择

              </Button>

            </Col>

            

            <Col xs={24} sm={3}>

              <Button

                type="dashed"

                icon={<LayoutOutlined />}

                onClick={() => setTemplateSelectorVisible(true)}

                block

                size="small"

              >

                选择模板

              </Button>

            </Col>

            

            <Col xs={24} sm={3}>

              <Button

                type="dashed"

                icon={<AppstoreOutlined />}

                onClick={() => setLayoutDesignerVisible(true)}

                block

                size="small"

              >

                自由设计

              </Button>

            </Col>



            <Col flex="none">

              <Space size={4} align="center">

                <span style={{ color: '#ff4d4f', fontSize: 14 }}>*</span>

                <span style={{ fontSize: 14 }}>行数</span>

                <Form.Item

                  name="rows"

                  style={{ marginBottom: 0 }}

                  rules={[

                    { required: true, message: '请输入行数' },

                    { type: 'number', min: 1, max: 20, message: '行数范围1-20' }

                  ]}

                >

                  <InputNumber 

                    style={{ width: '70px' }} 

                    placeholder="8"

                    min={1}

                    max={20}

                    size="small"

                  />

                </Form.Item>

              </Space>

            </Col>



            <Col flex="none">

              <Space size={4} align="center">

                <span style={{ color: '#ff4d4f', fontSize: 14 }}>*</span>

                <span style={{ fontSize: 14 }}>列数</span>

                <Form.Item

                  name="cols"

                  style={{ marginBottom: 0 }}

                  rules={[

                    { required: true, message: '请输入列数' },

                    { type: 'number', min: 1, max: 20, message: '列数范围1-20' }

                  ]}

                >

                  <InputNumber 

                    style={{ width: '70px' }} 

                    placeholder="8"

                    min={1}

                    max={20}

                    size="small"

                  />

                </Form.Item>

              </Space>

            </Col>

            

            <Col flex="none">

              <Space size={4} align="center">

                <span style={{ color: '#ff4d4f', fontSize: 14 }}>*</span>

                <span style={{ fontSize: 14 }}>座位模式</span>

                <Form.Item

                  name="seatType"

                  style={{ marginBottom: 0 }}

                  rules={[{ required: true, message: '请选择座位模式' }]}

                >

                  <Radio.Group disabled={selectedTemplate !== null} size="small">

                    <Radio value="single">单人</Radio>

                    <Radio value="double">双人</Radio>

                  </Radio.Group>

                </Form.Item>

              </Space>

            </Col>



            <Col flex="none">

              <Space size={4} align="center">

                <span style={{ color: '#ff4d4f', fontSize: 14 }}>*</span>

                <span style={{ fontSize: 14 }}>讲台位置</span>

                <Form.Item

                  name="podiumPosition"

                  style={{ marginBottom: 0 }}

                  rules={[{ required: true, message: '请选择讲台位置' }]}

                >

                  <Radio.Group 

                    size="small"

                    onChange={(e) => {

                      const val = e.target.value;

                      setLayout(prev => ({ ...prev, podiumPosition: val }));

                    }}

                  >

                    <Radio value="top">顶部</Radio>

                    <Radio value="bottom">底部</Radio>

                  </Radio.Group>

                </Form.Item>

              </Space>

            </Col>

          </Row>



          {/* 可折叠的高级选项 */}

          <Collapse 

            ghost

            style={{ marginTop: 16, backgroundColor: 'transparent' }}

          >

            <Panel 

              header="高级选项（可选）" 

              key="advanced"

              style={{ backgroundColor: '#f0f9ff', borderRadius: 4 }}

            >

              <div>

                {/* 智能排座配置 */}

                <Card 

                  size="small" 

                  title="智能排座选项" 

                  style={{ marginBottom: 12 }}

                  bodyStyle={{ padding: '12px' }}

                >

                <Space direction="vertical" style={{ width: '100%' }}>

                  <Form.Item

                    label="性别搭配"

                    name="genderArrangement"

                    tooltip="需要学生数据中包含性别信息"

                    style={{ marginBottom: 8 }}

                  >

                    <Radio.Group size="small">

                      <Radio value="mixed">男女混坐</Radio>

                      <Radio value="same">同性同桌</Radio>

                      <Radio value="none">不限制</Radio>

                    </Radio.Group>

                  </Form.Item>



                  <Form.Item

                    label="成绩搭配"

                    name="gradeArrangement"

                    tooltip="需要学生数据中包含成绩信息"

                    style={{ marginBottom: 8 }}

                  >

                    <Radio.Group size="small">

                      <Radio value="mixed">优劣搭配</Radio>

                      <Radio value="similar">成绩相近</Radio>

                      <Radio value="none">不限制</Radio>

                    </Radio.Group>

                  </Form.Item>



                  <Form.Item

                    label="身高搭配"

                    name="heightArrangement"

                    tooltip="需要学生数据中包含身高信息"

                    style={{ marginBottom: 8 }}

                  >

                    <Radio.Group size="small">

                      <Radio value="short-front">矮前高后</Radio>

                      <Radio value="mixed">高矮搭配</Radio>

                      <Radio value="none">不限制</Radio>

                    </Radio.Group>

                  </Form.Item>



                  <Form.Item

                    label="按号排座"

                    name="numberArrangement"

                    tooltip="按照学生的座号或学号排列"

                    style={{ marginBottom: 0 }}

                  >

                    <Radio.Group size="small">

                      <Radio value="asc">从小到大</Radio>

                      <Radio value="desc">从大到小</Radio>

                      <Radio value="none">不限制</Radio>

                    </Radio.Group>

                  </Form.Item>

                </Space>

              </Card>



              {/* 座位轮换设置 */}

              <Card 

                size="small" 

                title="座位轮换机制" 

                style={{ marginBottom: 12 }}

                bodyStyle={{ padding: '12px' }}

              >

                <Form.Item

                  label="轮换方式"

                  name="rotationType"

                  tooltip="设置座位定期轮换的方式"

                >

                  <Select placeholder="选择轮换方式" allowClear>

                    <Option value="front-back">前后轮回</Option>

                    <Option value="left-right">左右轮回</Option>

                    <Option value="diagonal">对角轮换</Option>

                    <Option value="custom">自定义规则</Option>

                  </Select>

                </Form.Item>



                <Alert

                  message="轮换说明"

                  description={

                    <>

                      <p>• <strong>前后轮回</strong>：最后一排移至第一排，其他排依次后移</p>

                      <p>• <strong>左右轮回</strong>：最右列移至最左列，其他列依次右移</p>

                      <p>• <strong>对角轮换</strong>：对角线位置互换</p>

                      <p>• <strong>自定义规则</strong>：按需配置轮换规则</p>

                    </>

                  }

                  type="info"

                  showIcon

                  style={{ fontSize: '12px' }}

                />

              </Card>



              {/* 过道配置 */}

              {!selectedTemplate && (

                <Card 

                  size="small" 

                  title="过道位置设置" 

                  style={{ marginBottom: 12 }}

                  bodyStyle={{ padding: '12px' }}

                >

                  <Form.Item

                    label="过道位置"

                    tooltip="在哪些列之后添加过道？例如：2,4,6"

                    style={{ marginBottom: 0 }}

                  >

                    <Select

                      mode="tags"

                      style={{ width: '100%' }}

                      placeholder="输入列号后回车，例如：2"

                      value={aislePositions.map(String)}

                      onChange={(values) => {

                        const positions = values.map(v => parseInt(v)).filter(n => !isNaN(n));

                        setAislePositions(positions);

                      }}

                    >

                      {Array.from({ length: 20 }, (_, i) => i + 1).map(num => (

                        <Option key={num} value={String(num)}>

                          第{num}列后

                        </Option>

                      ))}

                    </Select>

                  </Form.Item>

                </Card>

              )}

              </div>

            </Panel>

          </Collapse>



          {/* 操作按钮区域 - 改为一列显示 */}

          <Divider style={{ margin: '24px 0 16px' }}>

            <Space>

              操作

              <Button 

                type="link" 

                size="small" 

                icon={<QuestionCircleOutlined />}

                onClick={() => setHelpVisible(!helpVisible)}

              >

                {helpVisible ? '收起说明' : '使用说明'}

              </Button>

            </Space>

          </Divider>

          

          {helpVisible && (

            <Alert

              message="使用说明"

              description={

                <>

                  <p>• <strong>可视化选择</strong>：点击上方按钮快速选择</p>

                  <p>• <strong>手动输入</strong>：在下方输入框中精确设置</p>

                  <p>• <strong>模板</strong>：选择预设模板快速配置</p>

                  <p>• <strong>拖拽调整</strong>：排座后可拖动学生卡片</p>

                </>

              }

              type="info"

              showIcon

              closable

              onClose={() => setHelpVisible(false)}

              style={{ marginBottom: 16 }}

            />

          )}

          

          <Row gutter={[12, 12]}>
            <Col xs={24} sm={12} md={8} lg={6}>
              <SeatTemplateImport classId={classId} className={classInfo?.name || classInfo?.class_name} onSaved={fetchSeats} />
            </Col>

            <Col xs={24} sm={12} md={8} lg={4}>

              <Button 

                icon={<SaveOutlined />}

                onClick={handleSaveSeats}

                disabled={seats.length === 0}

                block

              >

                保存座位安排

              </Button>

            </Col>

            

            <Col xs={24} sm={12} md={8} lg={4}>

              <Button 

                icon={<SwapOutlined />}

                onClick={() => message.info('座位轮换功能开发中...')}

                disabled={seats.length === 0}

                block

              >

                执行座位轮换

              </Button>

            </Col>

            

            <Col xs={24} sm={12} md={8} lg={4}>

              <Button 

                icon={<DownloadOutlined />}

                onClick={handleExportSeats}

                disabled={seats.length === 0}

                block

              >

                导出Excel(列表)

              </Button>

            </Col>

            

            <Col xs={24} sm={12} md={8} lg={4}>

              <Button 

                icon={<DownloadOutlined />}

                onClick={() => message.info('布局导出功能开发中...')}

                disabled={seats.length === 0}

                block

              >

                导出Excel(布局)

              </Button>

            </Col>

            

            <Col xs={24} sm={12} md={8} lg={4}>

              <Button 

                icon={<UploadOutlined />}

                onClick={() => fileInputRef.current?.click()}

                block

              >

                导入Excel

              </Button>

            </Col>

            

            <Col xs={24} sm={12} md={8} lg={4}>

              <Popconfirm

                title="确定要清空所有座位吗？"

                onConfirm={handleClearSeats}

                okText="确定"

                cancelText="取消"

              >

                <Button 

                  icon={<DeleteOutlined />}

                  danger

                  disabled={seats.length === 0}

                  block

                >

                  清空座位

                </Button>

              </Popconfirm>

            </Col>

          </Row>

          

          <input 

            type="file" 

            ref={fileInputRef}

            accept=".xlsx,.xls"

            style={{ display: 'none' }}

            onChange={handleImportSeats}

          />



              {/* 自由设计模式的额外配置 */}

              {customLayoutMode && (

                <Card

                  size="small"

                  title="自由组合配置"

                  style={{ marginBottom: 16, backgroundColor: '#f0f5ff' }}

                >

                  <Space direction="vertical" style={{ width: '100%' }}>

                    <Alert

                      message="自由组合模式"

                      description={

                        <>

                          <p><strong>输入格式：</strong>用"-"分隔数字，例如：</p>

                          <p>• <strong>1-3-2</strong>：第1组1人，第2组3人，第3组2人，组间有过道</p>

                          <p>• <strong>2-2-2-2</strong>：四组，每组2人</p>

                          <p>• <strong>1-4-1</strong>：左右单人，中间4人座</p>

                        </>

                      }

                      type="info"

                      showIcon

                    />

                    

                    <Form.Item

                      label="输入布局组合"

                      name="customLayout"

                      rules={[

                        { required: true, message: '请输入布局组合' },

                        { 

                          pattern: /^(\d+)-(\d+)(-\d+)*$/, 

                          message: '格式错误，请使用"-"分隔数字，如：1-3-2' 

                        }

                      ]}

                      tooltip='用 "-" 分隔，如：1-3-2'

                    >

                      <Input 

                        placeholder="例如：1-3-2 或 2-4-2" 

                        onChange={(e) => {

                          const value = e.target.value;

                          if (value && /^(\d+)-(\d+)(-\d+)*$/.test(value)) {

                            // 解析布局字符串

                            const groups = value.split('-').map(n => parseInt(n));

                            let colIndex = 0;

                            const aisles = [];

                            groups.forEach((count, idx) => {

                              colIndex += count;

                              if (idx < groups.length - 1) {

                                aisles.push(colIndex);

                              }

                            });

                            setAislePositions(aisles);

                            message.success(`已解析：${groups.length}个分组，过道位置：${aisles.join(', ')}`);

                          }

                        }}

                      />

                    </Form.Item>

                    

                    <div>

                      <div style={{ marginBottom: 8, fontWeight: 500 }}>常用布局快捷设置：</div>

                      <Space wrap>

                        <Button

                          size="small"

                          onClick={() => {

                            layoutForm.setFieldsValue({ customLayout: '1-3-2' });

                            setAislePositions([1, 4]);

                            message.success('已设置：1-3-2 布局');

                          }}

                        >

                          1-3-2

                        </Button>

                        <Button

                          size="small"

                          onClick={() => {

                            layoutForm.setFieldsValue({ customLayout: '2-2-2-2' });

                            setAislePositions([2, 4, 6]);

                            message.success('已设置：2-2-2-2 布局');

                          }}

                        >

                          2-2-2-2

                        </Button>

                        <Button

                          size="small"

                          onClick={() => {

                            layoutForm.setFieldsValue({ customLayout: '1-4-1' });

                            setAislePositions([1, 5]);

                            message.success('已设置：1-4-1 布局');

                          }}

                        >

                          1-4-1

                        </Button>

                        <Button

                          size="small"

                          danger

                          onClick={() => {

                            layoutForm.setFieldsValue({ customLayout: '' });

                            setAislePositions([]);

                            message.success('已清除自定义布局');

                          }}

                        >

                          清除

                        </Button>

                      </Space>

                    </div>

                  </Space>

                </Card>

              )}



              {selectedTemplate && (aislePositions === 'all' || (Array.isArray(aislePositions) && aislePositions.length > 0)) && (

                <Alert

                  message="过道设置"

                  description={

                    aislePositions === 'all' 

                      ? '所有座位之间都有过道' 

                      : `过道位置：${aislePositions.map(p => `第${p}列后`).join('、')}`

                  }

                  type="info"

                  showIcon

                  style={{ marginBottom: 16 }}

                />

              )}



          </Form>

        </Card>



        {/* 下方：座位布局显示区域 */}

        <Card 

          title={

            <Space>

              座位布局图（支持拖拽调换）

              {seats.length > 0 && (

                <Button 

                  type="link" 

                  size="small" 

                  icon={<QuestionCircleOutlined />}

                  onClick={() => setLayoutInfoVisible(!layoutInfoVisible)}

                >

                  {layoutInfoVisible ? '收起信息' : '查看信息'}

                </Button>

              )}

            </Space>

          }

          bordered={false}

        >

            {seats.length > 0 && layoutInfoVisible && (

              <Space direction="vertical" style={{ width: '100%', marginBottom: 16 }}>

                <Alert

                  message={`当前座位布局：${layout.rows}行 × ${layout.cols}列 | ${layoutMode === 'double' ? '双人同桌模式' : '单人单座模式'} | 已安排${seats.filter(s => s.student_name).length}名学生`}

                  type="success"

                  showIcon

                  closable

                  onClose={() => setLayoutInfoVisible(false)}

                />

                {selectedTemplate && (

                  <Alert

                    message={`使用模板：${selectedTemplate.name}`}

                    description={selectedTemplate.description}

                    type="info"

                    showIcon

                  />

                )}

                {(aislePositions === 'all' || (Array.isArray(aislePositions) && aislePositions.length > 0)) && (

                  <Alert

                    message="过道信息"

                    description={

                      aislePositions === 'all' 

                        ? '所有座位之间都有过道' 

                        : `过道位置：${aislePositions.map(p => `第${p}列后`).join('、')}`

                    }

                    type="info"

                    showIcon

                  />

                )}

                <Alert

                  message="拖拽提示"

                  description="点击并拖动学生姓名卡片到另一个座位，可以交换两个学生的座位。拖动后记得点击【保存座位安排】按钮。"

                  type="info"

                  showIcon

                />

              </Space>

            )}



            <Spin spinning={loading}>

              <div style={{ 

                backgroundColor: '#fafafa', 

                borderRadius: 8,

                minHeight: 500,

                position: 'relative',

                overflow: 'auto'

              }}>

                {renderSeatGrid()}

              </div>

            </Spin>

          </Card>

      </div>

    );

  };

  

  export default SeatManagement;

